var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6624 1.5H14.8687L10.0499 7.00625L15.7187 14.5H11.2812L7.80303 9.95625L3.82803 14.5H1.61865L6.77178 8.60938L1.3374 1.5H5.8874L9.02803 5.65312L12.6624 1.5ZM11.8874 13.1812H13.1093L5.22178 2.75H3.90928L11.8874 13.1812Z",
    fill: "#5A6372"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterX);
export default __webpack_public_path__ + "static/media/twitterX.328a80f19e45f0f753e180e7a0280f0b.svg";
export { ForwardRef as ReactComponent };